<template>
  <div id="operaciones-editar">
    <vx-card v-if="this.mantenimiento" card-border class="mb-4" title="MANTENIMIENTO ACTIVADO" title-color="dark" collapseAction>
      <div class="vx-row w-full">
        <div class="vx-col w-full">
          <vs-alert color="danger" icon-pack="feather" icon="icon-info">
            <span>No se pueden crear operaciones nuevas mientras no termine el mantenimiento.</span>
          </vs-alert>
        </div>
      </div>
    </vx-card>

    <div v-if="!this.mantenimiento">

      <vx-card>
        <div class="mb-2 text-center item-features">
          <div class="vx-row">
            <div class="vx-col md:w-1/5 w-full">
              <div class="w-64 mx-auto mb-16 md:mb-0">
                <feather-icon icon="UserIcon" 
                  v-bind:svgClasses="[operacion.porcentajeCompletado>=25 ? 'h-8 w-8 text-success stroke-current' : 'h-8 w-8 textoGris stroke-current']" 
                  class="block mb-2" 
                />
                <span v-bind:class="[operacion.porcentajeCompletado>=25 ? 'font-semibold text-success' : 'font-semibold textoGris']">Datos de la operación</span>
                <p v-if="operacion.porcentajeCompletado===25" class="text-success">25% operación completa</p>
              </div>
            </div>
            <div class="vx-col md:w-1/5 w-full">
              <div class="w-64 mx-auto mb-16 md:mb-0">
                <feather-icon icon="ShoppingCartIcon" 
                  v-bind:svgClasses="[operacion.porcentajeCompletado>=50 ? 'h-8 w-8 text-success stroke-current' : 'h-8 w-8 textoGris stroke-current']" 
                  class="block mb-2" 
                />
                <span v-bind:class="[operacion.porcentajeCompletado>=50 ? 'font-semibold text-success' : 'font-semibold textoGris']">Productos</span>
                <p v-if="operacion.porcentajeCompletado===50" class="text-success">50% operación completa</p>
              </div>
            </div>
            <div class="vx-col md:w-1/5 w-full">
              <div class="w-64 mx-auto mb-16 md:mb-0">
                <feather-icon icon="InfoIcon" 
                  v-bind:svgClasses="[operacion.porcentajeCompletado>=75 ? 'h-8 w-8 text-success stroke-current' : 'h-8 w-8 textoGris stroke-current']" 
                  class="block mb-2" 
                />
                <span v-bind:class="[operacion.porcentajeCompletado>=75 ? 'font-semibold text-success' : 'font-semibold textoGris']">Detalle productos</span>
                <p v-if="operacion.porcentajeCompletado===75" class="text-success">75% operación completa</p>
              </div>
            </div>
            <div class="vx-col md:w-1/5 w-full">
              <div class="w-64 mx-auto mb-16 md:mb-0">
                <feather-icon icon="FileTextIcon" 
                  v-bind:svgClasses="[operacion.porcentajeCompletado===100 ? 'h-8 w-8 text-success stroke-current' : 'h-8 w-8 textoGris stroke-current']" 
                  class="block mb-2" 
                />
                <span v-bind:class="[operacion.porcentajeCompletado===100 ? 'font-semibold text-success' : 'font-semibold textoGris']">Documentación</span>
                <p v-if="operacion.porcentajeCompletado===100" class="text-success">100% operación completa</p>
              </div>
            </div>
            <div class="vx-col md:w-1/5 w-full">
              <div>
                <vs-button class="w-full mb-2" @click="lanzar('LANZAR')" :disabled="lanzarDisabled">Lanzar</vs-button>
                <vs-button class="w-full mt-2" @click="lanzar('PENDIENTE DE FIRMA')" :disabled="lanzarDisabled">Pendiente firma</vs-button>
              </div>
            </div>
          </div>
        </div>
        <vs-progress class="md:w-4/5" :height="20" :percent="operacion.porcentajeCompletado" color="success">{{operacion.porcentajeCompletado}}%</vs-progress>
        
        <vs-divider />

        <vs-tabs v-model="solapaActiva" class="tab-action-btn-fill-conatiner">
          <!-- Operación -->
          <vs-tab label="Operación" icon-pack="feather" icon="icon-book-open">
            <div class="tab-text">
              <operaciones-edit-operacion @cambiarSolapa="actualizarSolapaActiva" class="mt-4" />
            </div>
          </vs-tab>
          <!-- Cliente -->
          <vs-tab label="Cliente" icon-pack="feather" icon="icon-user">
            <div class="tab-text">
              <operaciones-edit-cliente class="mt-4" />
            </div>
          </vs-tab>
          <!-- Decisor -->
          <vs-tab label="Decisor" icon-pack="feather" icon="icon-users">
            <div class="tab-text">
              <operaciones-edit-decisor class="mt-4" />
            </div>
          </vs-tab>
          <!-- Dirección instalación -->
          <vs-tab label="Dir. Instalación" icon-pack="feather" icon="icon-map-pin">
            <div class="tab-text">
              <operaciones-edit-direccion class="mt-4" />
            </div>
          </vs-tab>
          <!-- Productos -->
          <vs-tab label="Productos" icon-pack="feather" icon="icon-shopping-cart">
            <div class="tab-text">
              <operaciones-edit-productos class="mt-4" @actualizar-barra-porcentaje-completado="actualizarOperacion()" />
            </div>
          </vs-tab>
          <!-- Productos detalle-->
          <vs-tab label="Detalle de productos" icon-pack="feather" icon="icon-info">
            <div class="tab-text">
              <operaciones-edit-productos-detalle class="mt-4" @actualizar-barra-porcentaje-completado="actualizarOperacion()" />
            </div>
          </vs-tab>
          <!-- Documentación  -->
          <vs-tab label="Documentación" icon-pack="feather" icon="icon-file-text">
            <div class="tab-text">
              <operaciones-edit-documentacion class="mt-4" @actualizar-barra-porcentaje-completado="actualizarOperacion()" />
            </div>
          </vs-tab>
          <!-- Comentarios  -->
          <vs-tab label="Comentarios" icon-pack="feather" icon="icon-message-square">
            <div class="tab-text">
              <operaciones-edit-comentarios class="mt-4" />
            </div>
          </vs-tab>
        </vs-tabs>
      </vx-card>

    </div>

  </div>
</template>

<script>
import operacionesStore from '@/store/gestion/operaciones/index.js'
import empresasStore from '@/store/configuracion/empresas/index.js'

import operacionesEditOperacion from './OperacionesEditOperacion'
import operacionesEditCliente from './OperacionesEditCliente'
import operacionesEditDecisor from './OperacionesEditDecisor'
import operacionesEditDireccion from './OperacionesEditDireccion'
import operacionesEditProductos from './OperacionesEditProductos'
import operacionesEditProductosDetalle from './OperacionesEditProductosDetalle'
import operacionesEditDocumentacion from './OperacionesEditDocumentacion'
import operacionesEditComentarios from './OperacionesEditComentarios'

export default {
  name: 'OperacionesEdit',
  components: {
    operacionesEditOperacion,
    operacionesEditCliente,
    operacionesEditDecisor,
    operacionesEditDireccion,
    operacionesEditProductos,
    operacionesEditProductosDetalle,
    operacionesEditDocumentacion,
    operacionesEditComentarios
  },
  data () {
    return {
      operacion: {},
      solapaActiva: 0,
      mantenimiento: null
    }
  },
  computed: {
    lanzarDisabled () {
      let disabled = true
      if (this.operacion.porcentajeCompletado === 100 && this.operacion.valEstado.estado === 'INCOMPLETA') disabled = false
      return disabled
    }
  },
  methods: {
    actualizarSolapaActiva (solapa) {
      this.solapaActiva = solapa
    },
    actualizarOperacion () {
      this.operacion = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion))
    },
    async lanzar (tipo) {
      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'

      const o = {}
      o.id = this.operacion.id

      tipo === 'LANZAR' ? o.valEstado = '/api/val_estados/2' : o.valEstado = '/api/val_estados/3'

      await this.$store.dispatch('operacionesStore/updateOperacion', o)
        .then(() => { 
          this.showUpdateSuccess()
        })
        .catch((error) => {
          this.showUpdateError(error)
        })

      this.operacion = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion))
      this.$router.push({name: 'operaciones'})
    },
    showUpdateSuccess () {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'success',
        title: 'OPERACIÓN LANZADA',
        text: 'La operación ha sido lanzada correctamente.'
      })
    },
    showUpdateError (error) {
      this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
      this.$vs.notify({
        color: 'danger',
        title: 'ERROR',
        text: error
      })
    }
  },
  async created () {
    if (!operacionesStore.isRegistered) {
      this.$store.registerModule('operacionesStore', operacionesStore)
      operacionesStore.isRegistered = true
    }
    if (!empresasStore.isRegistered) {
      this.$store.registerModule('empresasStore', empresasStore)
      empresasStore.isRegistered = true
    }
    const empresaId = 1

    await this.$store.dispatch('empresasStore/getMantenimiento', empresaId)
    this.mantenimiento = this.$store.state.empresasStore.mantenimiento 

    this.operacion = JSON.parse(JSON.stringify(this.$store.state.operacionesStore.operacion))

    if (this.$store.state.operacionesStore.altaOperacion === true) this.solapaActiva = 4

    this.$vs.loading.close()
  },
  async destroyed () {
    // Poñemos a FALSE a propiedade que habilita a pestaña Decisor cando se cambia o tipo de cliente a EMPRESA
    await this.$store.dispatch('operacionesStore/crearDecisor', false)
    // Poñemos a FALSE (por se non estivera) a propiedade que indica se estamos dando de alta unha operación para ir directamente á solapa de productos
    await this.$store.dispatch('operacionesStore/altaOperacion', false)
  }
}
</script>